import { ContentBlock } from "eddev/blocks"
import { createContext, useContext } from "react"

// type PersonBlock = Extract<ContentBlock, { slug: "content/people-grid-item" }>

const PeopleGridContext = createContext<{
  onSelect: (item: string) => void
  activeItem?: string
  renderTarget: HTMLElement | null
}>(undefined!)

export const PeopleGridProvider = PeopleGridContext.Provider

export const usePeopleGrid = () => {
  return useContext(PeopleGridContext)
}
